/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AuthSupportRequestSortFieldName } from '../../models/auth-support-request-sort-field-name';
import { AuthSupportsRequestPagedList } from '../../models/auth-supports-request-paged-list';
import { AuthSupportsRequestState } from '../../models/auth-supports-request-state';
import { SortDirection } from '../../models/sort-direction';

export interface ListAuthSupportsRequests$Params {

/**
 * The list items offset
 */
  offset?: number;

/**
 * The list items limit
 */
  limit?: number;

/**
 * Indicates the field to use for sorting the data:
 *   * CREATED_DATE : When the request was created
 *   * SUBSCRIPTION_NAME : The name of the subscription linked to the request
 */
  sortFieldName?: AuthSupportRequestSortFieldName & any;

/**
 * Sort direction : ASC, DESC
 */
  sortDirection?: SortDirection & any;
  subscriptionsUid?: Array<string>;
  statesFilter?: Array<AuthSupportsRequestState>;
}

export function listAuthSupportsRequests(http: HttpClient, rootUrl: string, params?: ListAuthSupportsRequests$Params, context?: HttpContext): Observable<StrictHttpResponse<AuthSupportsRequestPagedList>> {
  const rb = new RequestBuilder(rootUrl, listAuthSupportsRequests.PATH, 'get');
  if (params) {
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
    rb.query('sortFieldName', params.sortFieldName, {});
    rb.query('sortDirection', params.sortDirection, {});
    rb.query('subscriptionsUid', params.subscriptionsUid, {"style":"form","explode":false});
    rb.query('statesFilter', params.statesFilter, {"style":"form","explode":false});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AuthSupportsRequestPagedList>;
    })
  );
}

listAuthSupportsRequests.PATH = '/custom/auth-supports-requests';
